import { render, staticRenderFns } from "./CountryDetailsView.vue?vue&type=template&id=8654d252"
import script from "./CountryDetailsView.vue?vue&type=script&lang=js"
export * from "./CountryDetailsView.vue?vue&type=script&lang=js"
import style0 from "./CountryDetailsView.vue?vue&type=style&index=0&id=8654d252&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports